<template>
  <div class="gate main-cnt">
    <div class="title">自助购票机列表</div>
    <div class="content">
      <common-table ref="gateTable" tableHeight="calc(100vh - 325px)" :ischeck="false" :ispaging="true"
        :apiName="BasicApi.tvmList" :filters="filters" :columns="tableColumns" 
          @projectChange="projectChange" @updateTvm="updateTvm" @updateConfig="updateConfig">
        <template #operate>
          <el-button type="primary" round @click="showAddDialog"
            v-if="authData.indexOf('r_smChhlYS4Wz2F5Ev0H3tNckHN7ZR') != -1">
            <el-icon><i class="iconfont icon-a-lianhe4"></i></el-icon>
            新增自助购票机</el-button>
        </template>
      </common-table>
    </div>

    <!-- 新增/编辑 自助购票机弹框 -->
    <w-dialog ref="addDialog" class="add-dialog" :title="ruleForm.tvm_id ? '编辑自助购票机' : '新增自助购票机'" width="55%"
      :confirmText="ruleForm.tvm_id ? '确认编辑' : '确认新增'" btnWidth="140px" top="20vh" @wConfirm="confirm">
      <el-form class="add-form" ref="addForm" :model="ruleForm" :rules="rules" labelPosition="top">
        <el-form-item label="所属项目" prop="tvm_pid">
          <el-select v-model="ruleForm.tvm_pid" clearable placeholder="请选择所属项目">
            <el-option :label="item.p_name" :value="item.p_id" v-for="item in projectOptions"
              :key="item.p_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="所属景区" prop="tvm_sid">
          <el-select v-model="ruleForm.tvm_sid" :disabled="!ruleForm.tvm_pid ? true : false" clearable
            placeholder="请选择所属景区">
            <el-option :label="item.s_name" :value="item.s_id" v-for="item in scenicOptions"
              :key="item.s_id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="闸机名称" prop="tvm_name">
          <el-input v-model="ruleForm.tvm_name" placeholder="请输入闸机名称"></el-input>
        </el-form-item>
      </el-form>
    </w-dialog>
    <TvmConfigDialog ref="tvmConfigDialog" :configData="configData"  />


  </div>
</template>

<script setup>
import { ref, reactive, onMounted, computed, watch } from "vue";
import { ElMessage } from "element-plus";
import { BasicApi } from "@/plugins/api.js";
import { useStore } from "vuex";
import { checkStr } from "@/utils/common.js";
import TvmConfigDialog from "@/views/basic/components/TvmConfigDialog.vue";

const store = useStore();
const menuTokens = computed(() => store.state.menuToken.menuTokens);
const authData = ref([]);
watch(
  () => menuTokens.value,
  (data) => {
    if (data.length) {
      authData.value = data;
    }
  },
  {
    deep: true,
    immediate: true,
  }
);
/** 筛选条件列表 */
const filters = ref([
  {
    filterType: "search",
    name: "keyword",
    value: "",
    placeholder: "搜索闸机编号、入口或车场名称",
  },
  {
    filterType: "select",
    name: "p_id",
    value: "",
    placeholder: "请选择项目",
    options: [],
    val: "p_id",
    lab: "p_name",
    action: "projectChange",
  },
  {
    filterType: "select",
    name: "s_id",
    value: "",
    placeholder: "请选择景区",
    options: [],
    val: "s_id",
    lab: "s_name",
  },
]);
/** 表格配置数据 */
const tableColumns = ref([
  {
    prop: "tvm_id",
    label: "序号",
    minWidth: 40,
    color: "--text-third-color",
  },
  {
    prop: "scenic",
    objKey: "s_name",
    label: "所属景区",
    type: "obj",
    minWidth: 320,
    color: "--text-third-color",
  },
  {
    prop: "tvm_name",
    label: "名称",
    minWidth: 120,
    color: "--text-color",
  },
  {
    prop: "tvm_status_text",
    label: "状态",
    minWidth: 60,
    color: "--text-color",
  },
  {
    prop: "tvm_sn",
    label: "序列号",
    minWidth: 120,
    color: "--text-color",
  },
  {
    type: "operation",
    prop: "",
    label: "操作",
    minWidth: 200,
    bottons: [
      {
        name: "编辑",
        action: "updateTvm",
        token: "r_NfwxW5Sd1qLP8WNYf3pIMk1UA27y",
        className: "theme-font-btn",
      },
      {
        name: "配置",
        action: "updateConfig",
        token: "r_NfwxW5Sd1qLP8WNYf3pIMk1UA27y",
        className: "black-font-btn",
      },
    ],
  },
]);
/** 闸机表格对象 */
const gateTable = ref(null);
const tvmConfigDialog = ref(null);
const configData = ref({
  homeAds: [],
  promoAds: [],
  scenicPhone: '',
  hotelPhone: '',
  qrcode: ''
});
const updateConfig = (row) => {
 
  tvmConfigDialog.value.show(row);
};



/** 项目改变处理 */
const projectChange = (row) => {
  filters.value[2].value = "";
  filters.value[2].options = [];
  // 获取闸机表格数据
  gateTable.value.tableLoad();
  if (row.value) {
    // 获取景区数据
    BasicApi.getScenicByProject({ pid: row.value }).then((res) => {
      if (res.Code === 200) {
        filters.value[2].options = res.Data ? res.Data : [];
      } else {
        let msg = res.Message ? res.Message : "获取景区数据失败！";
        ElMessage.error(msg);
      }
    });
  }
};
/** 更新自助购票机 */
const updateTvm = (row) => {
  addDialog.value.show();
  ruleForm.value = {
    tvm_id: row.tvm_id,
    tvm_sid: row.tvm_sid,
    tvm_pid: row.tvm_pid,
    tvm_name: row.tvm_name,
  };
};

/** 新增弹框 */
const addDialog = ref(null);
/** 表单对象 */
const addForm = ref(null);
/** 表单数据对象 */
const ruleForm = ref({
  tvm_sid: "", // 景区
  tvm_pid: "", //项目
  tvm_name: "", // 闸机名称
});
const scenicOptions = ref([]);
watch(
  () => ruleForm.value.tvm_pid,
  (v) => {
    if (v) {
      if (!ruleForm.value.tvm_id) {
        ruleForm.value.tvm_sid = "";
      }
      BasicApi.getScenicByProject({ pid: v }).then((res) => {
        scenicOptions.value = res.Data;
      });
    }
  },
  {
    deep: true,
  }
);
const scenicEntranceOptions = ref([]);

watch(
  () => ruleForm.value.s_id,
  (v) => {
    if (v) {
      ruleForm.value.dg_seid = "";
      BasicApi.getEntranceByScenic({ se_sid: v }).then((res) => {
        scenicEntranceOptions.value = res.Data;
      });
    }
  },
  {
    deep: true,
  }
);
/** 表单规则对象 */
const rules = reactive({
  s_id: [
    {
      required: true,
      message: "请选择所属景区",
      trigger: "change",
    },
  ],
  dg_pid: [
    {
      required: true,
      message: "请选择所属项目",
      trigger: "change",
    },
  ],
  dg_seid: [
    {
      required: true,
      message: "请选择所属入口",
      trigger: "change",
    },
  ],
  dg_name: [
    {
      required: true,
      message: "请选择闸机",
      trigger: "change",
    },
  ],
  dg_sn: [
    {
      required: true,
      message: "控制机序号",
      trigger: "blur",
    },
  ],
});
/** 弹出 新增闸机 弹框 */
const showAddDialog = () => {
  addDialog.value.show();
  ruleForm.value = {
    tvm_sid: "", // 景区
    tvm_pid: "", //项目
    tvm_name: "", // 闸机名称
  };
};

/** 视频预览弹框 */
const projectOptions = ref([]);
/** 获取项目数据 */
const getProjectData = () => {
  BasicApi.projectSelect().then((res) => {
    if (res.Code === 200) {
      filters.value[1].options = res.Data ? res.Data : [];
      projectOptions.value = res.Data ? res.Data : [];
    } else {
      let msg = res.Message ? res.Message : "获取项目数据失败！";
      ElMessage.error(msg);
    }
  });
};
function confirm() {
  addDialog.value.isLoading = true;
  if (ruleForm.value.dg_sn && !checkStr(ruleForm.value.dg_sn, "letterNumber")) {
    ElMessage.warning({
      message: "控制机序号必须是字母和数字！",
    });
    addDialog.value.isLoading = false;
    return false;
  }
  const parmas = {
    tvm_pid: ruleForm.value.tvm_pid, //项目
    tvm_sid: ruleForm.value.tvm_sid, //入口
    tvm_name: ruleForm.value.tvm_name, // 闸机名称
  };
  if (ruleForm.value.tvm_id) {
    parmas.tvm_id = ruleForm.value.tvm_id;
    BasicApi["tvmEdit"](parmas).then((res) => {
      addDialog.value.isLoading = false;
      if (res.Code === 200) {
        ElMessage.success(`操作成功！`);
        addDialog.value.close();
        gateTable.value.tableLoad();
      } else {
        let msg = res.Message ? res.Message : `操作失败！`;
        ElMessage.error(msg);
      }
    });
  } else {
    BasicApi["tvmAdd"](parmas).then((res) => {
      addDialog.value.isLoading = false;
      if (res.Code === 200) {
        ElMessage.success(`操作成功！`);
        addDialog.value.close();
        gateTable.value.tableLoad();
      } else {
        let msg = res.Message ? res.Message : `操作失败！`;
        ElMessage.error(msg);
      }
    });
  }
}
onMounted(() => {
  // 获取项目数据
  getProjectData();
  // 获取闸机表格数据
  gateTable.value.tableLoad();
});
</script>

<style lang="scss" scoped>
.gate {
  font-family: "Source Han Sans CN";

  .content {
    padding: 20px;
  }

  .el-button {
    width: 160px;
  }

  .add-dialog {
    .el-dialog {
      min-width: 840px;

      .el-dialog__body {
        padding: 10px 15px 50px;

        .add-form {
          display: flex;
          flex-wrap: wrap;

          .el-form-item {
            width: 33.3%;
            padding: 20px 15px 0;
            margin-bottom: 0;

            .el-form-item__content {
              .el-select {
                width: 100%;

                .el-input {
                  width: 100%;
                }
              }
            }
          }

          .el-form-item.upload {
            width: 100%;
          }

          .el-divider {
            margin: 30px 0 0 15px;
            width: calc(100% - 30px);
          }
        }
      }
    }
  }


}
</style>
